import {SurveyPreset} from 'client/common/types';

const presets: any = {};

for (const key of Object.values(SurveyPreset)) {
    presets[key] = `survey-create__preset-${key}`;
}

export const testIds = presets as {[x in SurveyPreset]: `survey-create__preset-${x}`};
